import { Component } from '@verndale/core';
import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el
    };
  }

  addListeners() {
    const urlToShare = window.location.href;
    const pageTitle = document.title;
    const linkedinButton = this.dom.$el.querySelector('.linkedin');
    const twitterButton = this.dom.$el.querySelector('.twitter');

    const copyLinkButton = this.dom.$el.querySelector('[data-copy-link]');
    if (copyLinkButton) {
      copyLinkButton.addEventListener('click', this.copyLink.bind(this));
    }

    if (linkedinButton) {
      const linkedinUrl = `${linkedinButton.getAttribute('href')  }?mini=true&url=${encodeURIComponent(urlToShare)}`;
      linkedinButton.setAttribute('href', linkedinUrl);
    }

    if (twitterButton) {
      const twitterUrl = `${twitterButton.getAttribute('href')  }?title=${encodeURIComponent(pageTitle)}&url=${encodeURIComponent(urlToShare)}`;
      twitterButton.setAttribute('href', twitterUrl);
    }

  }

  async copyLink() {
    const { $el } = this.dom;
    const urlToCopy = window.location.href;

    try {
      await navigator.clipboard.writeText(urlToCopy);

      const copyLinkButton = this.dom.$el.querySelector('[data-copy-link]');
      if (copyLinkButton) {
        const textNode = copyLinkButton.childNodes[2];

        if (textNode && textNode.nodeType === 3) {
          const originalText = textNode.textContent;
          textNode.textContent = ' Copied!';

          setTimeout(() => {
            textNode.textContent = originalText;
          }, 5000);
        }
      }
    } catch (err) {
      //error
    }
  }
}
export default Module;
